import { ACCOUNT_PANE_PATH } from "../../app/api/routeConstants";

export const FETCH_EMPLOYER_PAID_JOBS = "FETCH_EMPLOYER_PAID_JOBS";
export const FETCH_EMPLOYER_FREE_JOBS = "FETCH_EMPLOYER_FREE_JOBS";
export const FETCH_EMPLOYER_DRAFT_JOBS = "FETCH_EMPLOYER_DRAFT_JOBS";
export const SELECT_EMPLOYER_DRAFT_JOB = "SELECT_EMPLOYER_DRAFT_JOB";
export const SELECT_EMPLOYER_REPOST_JOB = "SELECT_EMPLOYER_REPOST_JOB";
export const FETCH_EMPLOYER_PAID_COMPANY_FEATURED_LOGOS =
  "FETCH_EMPLOYER_PAID_COMPANY_FEATURED_LOGOS";
export const FETCH_EMPLOYER_FREE_COMPANY_FEATURED_LOGOS =
  "FETCH_EMPLOYER_FREE_COMPANY_FEATURED_LOGOS";
export const FETCH_EMPLOYER_COMPANY_PROFILE = "FETCH_EMPLOYER_COMPANY_PROFILE";
export const FETCH_EMPLOYER_COUPONS = "FETCH_EMPLOYER_COUPONS";
export const FETCH_EMPLOYER_MODE = "FETCH_EMPLOYER_MODE";
export const FETCH_CUSTOMER_DETAILS = "FETCH_CUSTOMER_DETAILS";
export const FETCH_OPEN_INVOICES = "FETCH_OPEN_INVOICES";

export const EMPTY_SUBSCRIPTION = {
  metadata: {},
  id: null,
  isActive: false,
  isUse: false,
  isLimitReached: false,
  isUnlimitedJobs: false,
  status: null,
  planDetails: {
    name: "",
    billing: "",
    limits: "",
    jobsPerCycle: "",
  },
  startedAt: null,
  currentPeriodStart: null,
  currentPeriodEnd: null,
  cancelAtPeriodEnd: null,
};

export const EMPTY_DISCOUNT = {
  id: null,
  name: "",
  isValid: false,
  couponDetails: {
    name: "",
    details: "",
    services: "",
  },
  amountOff: null,
  percentOff: null,
};

export const EMPLOYER_INITIAL_STATE = {
  jobs: [],
  draftJobs: [],
  selectedDraftJob: null,
  selectedRepostJob: null,
  companyFeaturedLogos: [],
  freebies: {
    jobs: [],
    companyFeaturedLogos: [],
  },
  coupons: [],
  companyProfile: null,
  mode: {
    newFeatures: [],
  },
  subscription: EMPTY_SUBSCRIPTION,
  discount: EMPTY_DISCOUNT,
  openInvoices: 0,
};

export const JOB_POST_TYPE = {
  underReview: "underReview",
  current: "current",
  expired: "expired",
  draft: "draft",
};

export const PROMOTION_SERVICE_TYPE = {
  underReview: "underReview",
  active: "active",
  expired: "expired",
};

export const COMPANY_PROMOTION_FEATURED_LOGO = "Company Logo Feature";

export const MANAGE_JOBS = "manage-jobs";
export const POST_JOB = "post-job";
export const COMPANY_PROFILE = "company-profile";
export const PROMOTION_SERVICES = "promotion-services";
export const COUPONS_AND_REWARDS = "coupons-and-rewards";

export const MANAGE_JOBS_INDEX = 0;
export const POST_JOB_INDEX = 1;
export const COMPANY_PROFILE_INDEX = 2;
export const PROMOTION_SERVICES_INDEX = 3;
export const COUPONS_AND_REWARDS_INDEX = 4;
export const ACCOUNT_EMPLOYER_INDEX = 5;

export const getLocationFromIndex = (index) => {
  if (index === MANAGE_JOBS_INDEX) return MANAGE_JOBS;
  if (index === POST_JOB_INDEX) return POST_JOB;
  if (index === COMPANY_PROFILE_INDEX) return COMPANY_PROFILE;
  if (index === PROMOTION_SERVICES_INDEX) return PROMOTION_SERVICES;
  if (index === COUPONS_AND_REWARDS_INDEX) return COUPONS_AND_REWARDS;
  if (index === ACCOUNT_EMPLOYER_INDEX) return ACCOUNT_PANE_PATH;
};

export const EMPTY_BILLING_ADDRESS = {
  lineOne: "",
  lineTwo: "",
  postcode: "",
  city: "",
};
